export default "__VITE_ASSET__BEotB7Gv__"